import { FC } from 'react'
import Link from 'next/link'
import { useCustomRouter, useGetTranslations } from '@/root/shared-hooks'
import { MenuItem, SocialFooterItem, LinkToGroupItem } from '@/root/shared-types'
import { ContentContainer } from '@/root/components/shared'
import { Icon } from '@/root/ui/shared'

interface FooterSocialProps {
  socialItems: SocialFooterItem[]
  menuItems: MenuItem[]
  linkToGroupItems: LinkToGroupItem[]
}

const FooterSocial: FC<FooterSocialProps> = ({ socialItems, menuItems, linkToGroupItems }) => {
  const currentYear = new Date().getFullYear()
  const { getTranslation } = useGetTranslations()
  const { locale } = useCustomRouter()

  return (
    <div className="bg-base-dark">
      <ContentContainer>
        <div className="flex flex-col justify-center gap-6 px-5 py-8 text-white sm:flex-row sm:items-center">
          <div className="flex min-w-32 shrink flex-col gap-1 text-xl md:shrink-0"></div>
          <div className="flex flex-col gap-8">
            <div className="flex items-center justify-center gap-3 sm:justify-end">
              {socialItems.map(({ link, icon, title }) => (
                <Link className="darken" key={link} href={link} target="_blank">
                  {icon && <Icon ignoreRtl alt={icon} height={32} width={32} type={icon} />}
                  {title ? title : null}
                </Link>
              ))}
            </div>
            <div className="flex flex-col items-center justify-end gap-4 text-center text-sm sm:flex-row">
              <div className="text-base-very-light">
                {`©${currentYear} ${getTranslation('footerCopyright')}`}{' '}
                <Link
                  href="https://bora.systems/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline underline-offset-2 hover:opacity-90"
                >
                  Bora Systems
                </Link>
              </div>
              <div className="xs:flex-row xs:gap-4 flex flex-col items-center gap-2">
                {menuItems.map(({ id, link, subject }) => (
                  <Link key={id} className="darken" href={`/${locale}${link}`}>
                    {subject}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </ContentContainer>
    </div>
  )
}

export default FooterSocial
